/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./src/js/_utils.js":
/*!**************************!*\
  !*** ./src/js/_utils.js ***!
  \**************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "setCookie": () => (/* binding */ setCookie),
/* harmony export */   "getCookie": () => (/* binding */ getCookie),
/* harmony export */   "closeMegamenu": () => (/* binding */ closeMegamenu),
/* harmony export */   "openMegamenu": () => (/* binding */ openMegamenu)
/* harmony export */ });
function setCookie(name, value, days) {
  var expires = "";

  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }

  document.cookie = name + "=" + (value || "") + expires + "; path=/";
}
function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
}
function closeMegamenu(megamenu, currentLink) {
  megamenu.classList.remove('active');
  megamenu.setAttribute('aria-expanded', 'false');

  if (window.innerWidth >= 1280) {
    const header = document.querySelector('.main-header');
    header.classList.remove('is-dark');
  }

  if (currentLink) {
    currentLink.classList.remove('active');
  }

  document.body.style.overflow = null;
}
function openMegamenu(megamenu, currentLink) {
  megamenu.classList.add('active');
  megamenu.setAttribute('aria-expanded', 'true');
  document.body.style.overflow = 'hidden';

  if (window.innerWidth >= 1280) {
    const header = document.querySelector('.main-header');
    header.classList.add('is-dark');
  }

  if (currentLink) {
    currentLink.classList.add('active');
  }

  var closeBtns = megamenu.querySelectorAll('.megamenu-close-action');
  closeBtns.forEach(closeBtn => {
    closeBtn.addEventListener("click", function close() {
      closeMegamenu(megamenu, currentLink);
      this.removeEventListener('click', close);
    });
  });
}

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be isolated against other modules in the chunk.
(() => {
/*!******************************************!*\
  !*** ./src/js/sections/announcements.js ***!
  \******************************************/
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../_utils */ "./src/js/_utils.js");


function announcementBarInit() {
  var $announcementClose = document.querySelectorAll(".announcement-bar-close-action");
  $announcementClose.forEach(element => {
    element.addEventListener("click", event => {
      const $bar = element.closest('.announcement-bar');
      (0,_utils__WEBPACK_IMPORTED_MODULE_0__.setCookie)('announcementBar-' + $bar.getAttribute('data-announcement-id'), 'closed');
      $bar.remove();
    });
  }); // Cookie business

  const $announcementBars = document.querySelectorAll('.announcement-bar.with-close');

  if ($announcementBars.length > 0) {
    $announcementBars.forEach($announcementBar => {
      const id = $announcementBar.getAttribute('data-announcement-id');

      if (!id) {
        $announcementBar.style.display = 'block';
      }

      const announcementBarCookie = (0,_utils__WEBPACK_IMPORTED_MODULE_0__.getCookie)('announcementBar-' + id);

      if (announcementBarCookie !== 'closed') {
        $announcementBar.style.display = 'block';
      }
    });
  }
}

announcementBarInit();
})();

/******/ })()
;